"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateLanguageCode = exports.languageCodeSchema = void 0;
var zod = _interopRequireWildcard(require("zod"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const languageCodeSchema = exports.languageCodeSchema = zod.string().regex(/^[A-Za-z]{2}$/).transform(val => val.toLowerCase());

/**
 * Validates the provided language code against the language code schema.
 *
 * @param languageCode - The language code to validate in form of two-letter code.
 * @returns The lowercased validated language code if the validation is successful, otherwise undefined.
 */
const validateLanguageCode = languageCode => {
  const result = languageCodeSchema.safeParse(languageCode);
  if (result.success) {
    return result.data;
  }
  return undefined;
};
exports.validateLanguageCode = validateLanguageCode;
//# sourceMappingURL=validateLanguageCode.js.map